import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, Typography, Spin, Button } from 'antd';
import JSONView from 'react-json-view';
import './AuditLogModal.css';

const { Text } = Typography;

@inject(
    'AuditLogStore'
)
@observer
class AuditLogModalPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false
        }
    }

    componentDidMount() {
    }

    // ON CLICK

    cancelAuditLogDetailOnClick = () => {
        this.props.AuditLogStore.setshowAuditLogModal(false);
    }

    render() {
        const {
            auditLog,
            auditLogModalLoading
        } = this.props.AuditLogStore;

        return (
            <>
                {
                    auditLog
                        ?
                        <>
                            <Spin spinning={auditLogModalLoading}>
                                <Row className='auditlogmodal-row-container'>
                                    <Col span={24} className='auditlogmodal-col'>
                                        <Row>
                                            <Col span={8} className='auditlogmodal-col-label'>
                                                <Text className='auditlogmodal-text-label'>Area</Text>
                                            </Col>
                                            <Col span={16} className='auditlogmodal-col-input'>
                                                <span>{auditLog.area}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='auditlogmodal-col'>
                                        <Row>
                                            <Col span={8} className='auditlogmodal-col-label'>
                                                <Text className='auditlogmodal-text-label'>Action</Text>
                                            </Col>
                                            <Col span={16} className='auditlogmodal-col-input'>
                                                <span>{auditLog.action}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='auditlogmodal-col'>
                                        <Row>
                                            <Col span={8} className='auditlogmodal-col-label'>
                                                <Text className='auditlogmodal-text-label'>Username</Text>
                                            </Col>
                                            <Col span={16} className='auditlogmodal-col-input'>
                                                <span>{auditLog.username}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='auditlogmodal-col'>
                                        <Row>
                                            <Col span={8} className='auditlogmodal-col-label'>
                                                <Text className='auditlogmodal-text-label'>Created At</Text>
                                            </Col>
                                            <Col span={16} className='auditlogmodal-col-input'>
                                                <span>{auditLog.createdDateString}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='auditlogmodal-col'>
                                        <Row>
                                            <Col span={8} className='auditlogmodal-col-label'>
                                                <Text className='auditlogmodal-text-label'>Detail</Text>
                                            </Col>
                                            <Col span={16} className='auditlogmodal-col-input json-viewer'>
                                                <JSONView src={JSON.parse(auditLog.data)} />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='auditlogmodal-col-button'>
                                        <Button type='primary' className='auditlogmodal-button' onClick={this.cancelAuditLogDetailOnClick}>Close</Button>
                                    </Col>
                                </Row>
                            </Spin >
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default AuditLogModalPage;
